import { render, staticRenderFns } from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=template&id=568f8528"
import script from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=style&index=0&id=568f8528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports